import calculatePointColor from "utilities/trend-chart/calculateGuldeline";
import { Guidelines } from "@sisuwellness/utilities";
import { PORTAL_IMAGE } from "constants/imagePath";
import { find, propEq } from "ramda";
import { METRIC_INDICATOR } from "./mapIndicators";
import { BLOOD_PRESSURE } from "constants/trend-charts";
import { theme } from "@sisuwellness/web-components";
import i18n from "../../i18n.js";

/**
 * Get metric data for given type
 * @param {string} type - type of metric
 * @param {object} data - citizen/healthcheck data
 *
 */
const getMetric = (type, data) => {
    const metricObject = calculatePointColor(type, data);

    const { key, rating, riskLevel, guideline } = metricObject;
    if (!guideline) return null;

    const { title, themeKey = "" } = METRIC_INDICATOR[type] || {};

    const totalRiskLevel = Object.keys(theme.guidelines[themeKey] || {}).length;

    const isRiskHigh = totalRiskLevel / (totalRiskLevel + 1) === riskLevel;

    return {
        title,
        rating: i18n.t(rating),
        isRiskHigh,
        risk: riskLevel * 100,
        recommendation: guideline.recommendation || "",
        color: theme.guidelines[themeKey]?.[key]?.sisuPortal?.hex
    };
};

/**
 * Get metric data by metric recommendation (BP Metric data)
 * @param {string} type - type of metric
 * @param {object} recommendation - metric recommendation object
 * @param {string} recommendation.rating - rating key
 */
export const getBPMetricBasedOnBPRecommendation = (type, recommendation, healthCheck = {}) => {
    if (type !== BLOOD_PRESSURE || !recommendation) return null;

    const { sys, dia } = healthCheck;
    let key, label, i18nKey, riskLevel;

    if (sys && dia) {
        // Preferred: recalculate from raw values (single source of truth)
        const guideline = new Guidelines.NHSBloodPressure.NationalHealthServiceBP(sys, dia);
        key = guideline.key;
        label = guideline.label;
        i18nKey = guideline.i18nKey;
        riskLevel = guideline.riskLevel;
    } else {
        // Fallback: map stored recommendation key (for records without raw sys/dia)
        const { rating } = recommendation;

        const legacyKeyMapping = {
            optimal: "normal",
            mildHypertension: "high",
            moderateHypertension: "high",
            severeHypertension: "severe"
        };
        const mappedRating = legacyKeyMapping[rating] || rating;

        const ranges = Guidelines.NHSBloodPressure.NationalHealthServiceBP.ranges;
        const matched = find(propEq("key", mappedRating), Object.values(ranges)) || {};
        key = matched.key;
        label = matched.label;
        i18nKey = matched.i18nKey;
        riskLevel = matched.riskLevel;
    }

    if (!key) return null;

    const { title, themeKey } = METRIC_INDICATOR[type];

    const totalRiskLevel = Object.keys(theme.guidelines[themeKey]).length;

    const isRiskHigh = totalRiskLevel / (totalRiskLevel + 1) === riskLevel;

    return {
        title,
        isRiskHigh,
        rating: label,
        i18nKey,
        icon: `${PORTAL_IMAGE}/healthHub/bloodpressure-unfaded.svg`,
        color: theme.guidelines[themeKey][key].sisuPortal.hex
    };
};

export default getMetric;
